import React from "react";
import { Button, Popover, Tag } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import "./ContentFilters.less";

const ContentFilterPopover = ({ content, selectedTags = [], onClear }) => {
    const hasActiveFilters = selectedTags.length > 0;

    return (
        <div className="content-filter-popover-wrap ml-auto">

            {hasActiveFilters ? (
                <div className="content-filter-popover__tags">
                    {selectedTags.map((tag) => (
                        <Tag className="content-filter-popover__tag" key={tag.key} closable onClose={tag.onClose}>
                            {tag.label}
                        </Tag>
                    ))}
                </div>
            ) : null}

            <Popover
                trigger="click"
                placement="bottomRight"
                overlayClassName="content-filter-popover"
                content={
                    <div className="content-filter-popover__content">
                        {content}
                        {hasActiveFilters ? (
                            <div className="content-filter-popover__footer">
                                <Button size="small" onClick={onClear}>Clear</Button>
                            </div>
                        ) : null}
                    </div>
                }>
                <Button
                    icon={<FilterOutlined />}
                    className={hasActiveFilters ? "content-filter-popover__button content-filter-popover__button--active" : "content-filter-popover__button"}>
                    Filter
                    {hasActiveFilters ? (
                        <span className="content-filter-popover__button-indicator">{selectedTags.length}</span>
                    ) : null}
                </Button>
            </Popover>

        </div>
    );
};

export default ContentFilterPopover;
